import { Card, CardBody, Col, Row } from "reactstrap";
import CountUp from "react-countup";
import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";

const CardStatistiqueItem = ({ title, icon, className, url, counterStart, counterEnd, counterDuration, stats = []}) => {
  return (
    <Col md={3}>
      <Link to={url} className="text-decoration-none">
        <Card className="card-animate">
          <CardBody className="d-flex flex-column h-100">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h3 className="fw-medium text-muted mb-0">{title}</h3>
              </div>
              <div>
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                    <FeatherIcon icon={icon} className={className} />
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center flex-grow-1">
              <h2 className="text-center mt-4 ff-secondary fw-semibold">
                <span className="counter-value">
                  <CountUp
                    start={counterStart}
                    end={counterEnd}
                    duration={counterDuration}
                  />
                </span>
              </h2>
            </div>
            <Row className="mt-4">
              {stats.map((stat, index) => (
                <Col key={index} className={stat.align || "text-left"}>
                  <div>
                    <p className="text-center mb-2 fw-semibold fs-12 text-muted">{stat.label}</p>
                    <h5 className="text-center fs-14 mb-0 view-type">{stat.value}</h5>
                  </div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Link>
    </Col>
  );
};

export default CardStatistiqueItem;
